<template>
  <div>
    <v-slide-y-transition mode="out-in">
      <v-navigation-drawer v-model="drawer" fixed right app>
        <v-list dense class="pt-3">
          <user-links></user-links>
          <v-list-tile to="/">
            <v-list-tile-action>
              <v-icon>fas fa-home</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Home</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider></v-divider>
          <v-list-tile
            v-for="item in items"
            :key="item.title"
            :to="{ name: item.name }"
            exact
          >
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile :to="{ name: 'blog' }">
            <v-list-tile-action>
              <v-icon>fas fa-blog</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Blog</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <the-sidenav-links></the-sidenav-links>
      </v-navigation-drawer>
    </v-slide-y-transition>
    <v-toolbar color="red darken-4" dark fixed app>
      <v-toolbar-title>
        <v-btn
          :style="letterSpacing"
          flat
          href="tel:+1-702-858-8778"
          class="pa-0 font-weight-bold"
        >
          702-858-8778
        </v-btn>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-side-icon aria-label="Menu" @click.stop="drawer = !drawer">
      </v-toolbar-side-icon>
    </v-toolbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { items } from '../json/items.json';
import TheSidenavLinks from './TheSidenavLinks';
import UserLinks from './UserLinks';

export default {
  name: 'TheSideNav',
  components: {
    TheSidenavLinks,
    UserLinks,
  },
  data() {
    return {
      drawer: null,
      dialog: false,
      letterSpacing: 'letter-spacing: 0.0625em;',
    };
  },
  computed: {
    ...mapGetters({
      user: 'user',
    }),
  },
  created() {
    this.items = items;
  },
};
</script>
